<ion-header>
  <ion-toolbar>
    <ion-title>Verificación de Seguridad</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding ion-text-center">
  <div class="otp-container">
    <ion-icon name="shield-checkmark-outline" class="otp-icon"></ion-icon>

    <h2>Ingresa el código OTP</h2>

    <p>
      Para proteger tu información y garantizar la seguridad de tus datos, necesitamos verificar tu identidad antes de actualizar tu información. Hemos enviado un código de verificación de <strong>4 dígitos</strong> vía
      <strong>{{ method === 'sms' ? 'SMS' : 'Correo electrónico' }}</strong>
      <span *ngIf="destination"> a {{ destination }}</span>.
      Ingresa el código recibido para continuar con la actualización de tus datos.
    </p>

    <!-- Formulario de 4 dígitos -->
    <div class="inputs-group" (paste)="onPaste($event)">
      <input
        *ngFor="let digit of digits; let i = index; trackBy: trackByFn"
        #digitInput
        type="text"
        inputmode="numeric"
        maxlength="1"
        [(ngModel)]="digits[i]"
        (input)="onDigitInput($event, i)"
        (keydown)="onKeyDown($event, i)"
        class="otp-digit-input"
        [disabled]="loading"
        autocomplete="off"
      />
    </div>

    <ion-button expand="block" class="ion-margin-top" (click)="verifyCode()">
      <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>

      <span *ngIf="!loading">Verificar y Continuar</span>
    </ion-button>

    <ion-button fill="clear" size="small" [disabled]="!canResend || resending" (click)="resendCode()">
      <ion-spinner *ngIf="resending" name="crescent"></ion-spinner>
      <span *ngIf="!resending && canResend">¿No recibiste el código? Reenviar</span>
      <span *ngIf="!resending && !canResend">Reenviar código en {{ resendCountdown }}s</span>
    </ion-button>

    <ion-button fill="clear" size="small" (click)="cancel()" [disabled]="loading">
      Cancelar
    </ion-button>
  </div>
</ion-content>
